var winMobile,
    clubsMobile = false;


$(window).on("load resize", function(){
    winMobile = $(window).width() <= 1024;
    if ((winMobile && !clubsMobile) || !winMobile && clubsMobile) {
        clubChange();
    }
})

function clubChange() {
    let clubList1 = $(".basic-clubs__list:first");
    let clubList2 = $(".basic-clubs__list:last");
    if (clubsMobile) {
        clubList2.prepend(clubList1.find(".basic-club:last"));
    } else {
        clubList1.append(clubList2.find(".basic-club:first"));
    }
    clubsMobile = !clubsMobile;
}